import React, { FC, useEffect } from 'react'

import { StaticPages } from 'store/pages/static/types'

import styled, { createGlobalStyle } from 'styled-components'
import { backgroundColor } from 'uiComponents/constants/colors'
import {
  mediaDesktopAndUp,
  mediaExtraLargeScreens,
  mediaMinL,
  mediaTabletAndUp,
} from 'uiComponents/constants/customMedia'
import CampaignText from '../CampaignText'
import DocumentHead from '../DocumentHead'
import JsonLd from '../JsonLd'
import Text from '../Text'

const CookieTableStyle = createGlobalStyle`
  body .content table {
    thead {
      font-weight: bold;
    }
    th, td {
      padding: 5px;
      text-align: left;

      &:nth-child(1) {
        width: 130px;
      }
      &:nth-child(2) {
        width: 100px;
      }
      &:nth-child(3) {
        width: 50%;
      }
    }
    tbody tr:nth-child(odd) {background-color: ${backgroundColor};}
  }
`

const ContentStyleProvider = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .content {
    width: calc(100% - 158px);

    @media ${mediaDesktopAndUp} {
      width: calc(100% - 198px);
    }

    @media ${mediaExtraLargeScreens} {
      width: calc(100% - 189px);
    }

    @media ${mediaMinL} {
      width: calc(100% - 194px);
    }
  }
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 23px;
  margin-top: 30px;
  max-width: 1400px;
  min-width: 768px;

  @media ${mediaTabletAndUp} {
    padding: 0 23px;
  }

  @media ${mediaDesktopAndUp} {
    padding: 0 19px;
  }

  @media ${mediaExtraLargeScreens} {
    padding: 0 23px;
  }

  @media ${mediaMinL} {
    padding: 0 23px;
  }
`

interface IStaticPageProps {
  staticContent: string
  staticJsonLd: string | null
  pageType: StaticPages
}

const StaticPage: FC<IStaticPageProps> = ({
  staticContent,
  staticJsonLd,
  pageType,
}) => {
  const textComponent =
    pageType === 'campaign_conditions' ? (
      <CampaignText />
    ) : (
      <Text htmlContent={staticContent} />
    )

  useEffect(() => {
    const hash = window.location.hash
    if (hash) {
      const element = document.getElementById(hash.substring(1))
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [])

  return (
    <React.Fragment>
      <ContentStyleProvider>
        {pageType === 'cookies' && <CookieTableStyle />}
        <DocumentHead />
        <Container className="container">
          <div className="content">{textComponent}</div>
          {staticJsonLd && <JsonLd content={staticJsonLd} />}
        </Container>
      </ContentStyleProvider>
    </React.Fragment>
  )
}

export default StaticPage
